import React from 'react';
import PropTypes from 'prop-types';
import { SpinnerLoader } from '..';
import classes from './CustomTable.module.scss';

const CustomTable = (props) => {
    const { children, isStriped, isRowHover, isLoading, noDataAvailable } = props;

    // if (noDataAvailable) {
    //     return <NoDataAvailable title="We’re sorry! No data found" text="No record found" />;
    // }

    return (
        <>
            <div className={`${classes.CustomTableWrap} ${isLoading ? classes.Loading : ''}`}>
                <table
                    className={`${classes.Table} ${isStriped ? classes.Striped : ''} ${
                        isRowHover ? classes.RowHover : ''
                    }`}
                >
                   
                    {children}
                    {isLoading && (
                        <tbody>
                            <tr>
                                <td>
                                    <div className={classes.Overlay}>
                                        <div className={classes.Overlay__Loader}>
                                            <SpinnerLoader size="large" />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </>
    );
};

CustomTable.propTypes = {
    isStriped: PropTypes.bool,
    isRowHover: PropTypes.bool,
    isLoading: PropTypes.bool,
    noDataAvailable: PropTypes.bool,
};

export default CustomTable;
